export const customStyles = {
  control: (styles, { selectProps: { typeOfInfoError } }) => ({
    ...styles,
    backgroundColor: "white",
    borderColor: typeOfInfoError ? "red" : "#C7CDD5",
    outline: "none",
    "&:hover": {
      outline: "none",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "#A4CBFD",
    },
    borderBottom: "1px solid #DFE3E9",
    paddingTop: "16px",
    paddingBottom: "16px",
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    backgroundColor: "#F3F8FF",
    border: "1px solid #A4CBFD",
    borderRight: "none",
    borderRadius: "2px",
    color: "#3D90FB",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    backgroundColor: "#F3F8FF",
    border: "1px solid #A4CBFD",
    borderLeft: "none",
    borderRadius: "2px",
    color: "#3D90FB",
  }),
};
